const cloudfront = window.cloudfrontEndpoint
	? window.cloudfrontEndpoint
	: '5h57ds2h3g.execute-api.ap-southeast-2.amazonaws.com/dev';
const host = window.gatewayEndpoint
	? window.gatewayEndpoint
	: 'dev-web-api.hungryjacks.com.au';
const apiKey = window.secretKey
	? window.secretKey
	: 'jM8Xe8Egu42kt7QCXLNzmcfMGzB9SSR1TRud8vQf';
const brazeWebKey = window.brazeWebKey
	? window.brazeWebKey
	: 'eb18602b-80a1-4b6b-bc09-28c85e0afc9c';

export default {
	apiKey,
	host,
	cloudfront,
	brazeWebKey,
	api: 'api.hungryjacks.io/v1',
	userApi: `${host}/api/v1/user`,
	tokenApi: `${cloudfront}/api/v1/token`,
	storeApi: `${host}/api/v1/stores`,
	feedbackApi: `${host}/api/v1/feedback`,
	voucherApi: `${host}/api/v1/rewards`,
	appScheme: 'hungryjacks://',
	competitionAPI: `${host}/api/v1/competition/entry`,
};
